import { render, staticRenderFns } from "./BranchEditView.vue?vue&type=template&id=38727195"
import script from "./BranchEditView.vue?vue&type=script&lang=js"
export * from "./BranchEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports